// Dev flags for trying things before they're built for real (owner feedback 23 Oct, round 2). Each is
// off unless sessionStorage has its key set to '1' (like `tq-force-full`), so the shipped app never
// shows them; the e2e screenshots switch them on.
//   tq-dev-autohide  the Map's stop bar shrinks to its dots after a few seconds idle

export type DevFlag = 'tq-dev-autohide'

export function devFlag(flag: DevFlag): boolean {
  try {
    return sessionStorage.getItem(flag) === '1'
  } catch {
    return false
  }
}
